import axios from 'axios';

export default {
    methods: {
        async defectoAll(ok, err) {
            try {
                let r = await axios.post('graphql', {
                    query: `{defectos{id desig}}`
                });
                ok(r.data.data)
            } catch (e) {
                err(e)
            }
        },

    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/defecto.js